__turbopack_context__.v({
  "root": "TemplatesHeader-module__2Dae2G__root",
  "sharing": "TemplatesHeader-module__2Dae2G__sharing",
  "topRow": "TemplatesHeader-module__2Dae2G__topRow",
});
